<!-- 券仓plus-支付兑换码-首页 -->
<template>
  <div
    :class="{
      'scenario-pay-exchange-index-page': true,
      'page-fixed-screen': pageFixedScreen,
    }"
  >
    <div class="rule-btn">
      <div class="btn" @click="toRecored">兑换记录</div>
      <div class="btn" @click="openRule">兑换规则</div>
    </div>
    <div class="goods-conent">
      <h2>{{ productData.productName }}</h2>
      <img
        v-if="productData.mainPic"
        :src="productData.mainPic"
        alt=""
        class="banner"
      />
      <div class="price" v-if="productData.salePrice">
        {{ productData.salePrice / 100 }}
      </div>
      <div class="sub">输入兑换码即可以折扣价购买商品</div>
    </div>
    <div class="input-content">
      <!-- 直充类型商品充值账户必填 -->
      <div class="input-box" v-if="productData.showType === 2">
        <van-field
          v-model="formData.clientAccount"
          label=""
          placeholder="请输入充值账号"
        />
      </div>

      <div class="input-box">
        <van-field
          v-model="formData.decryptSelfCouponId"
          label=""
          placeholder="请输入兑换码"
        />
      </div>
      <van-button type="primary" color="#000" block round @click="toBuy"
        >立即购买</van-button
      >
    </div>
    <div class="good-rule">
      <h4>商品说明</h4>
      <p class="content" v-html="productData.description"></p>
    </div>

    <!-- 兑换规则弹窗 -->
    <RulePopup ref="rulePopupRef" :appletInfo="appletInfo" />
    <!-- 订单安全校验loading弹窗 -->
    <OrderVerificationPopup ref="orderVerificationPopupRef" />
    <!-- 收获地址确认弹窗 -->
    <AddressPopup ref="addressPopupRef" @addressConform="addressConform" />
  </div>
</template>
<script>
import { loginApi, productList, userInfoApi, homePageApi, checkProductApi, checkCanBuyApi, placeorderApi } from '@/api/huijuinterface.js'
import RulePopup from './RulePopup'
import OrderVerificationPopup from './OrderVerificationPopup'
import AddressPopup from './AddressPopup'
import { wxApiEmpower } from '@/utils/common'

// import moment from 'moment'
// import { Toast } from 'vant'
export default {
  components: { RulePopup, OrderVerificationPopup, AddressPopup },
  data() {
    return {
      title: '支付兑换码',
      lotteryDisable: false, // 抽奖中
      meetWith: 1, // 抽奖中
      loginErrorMsg: '', // 登录失败提示
      productData: {
      }, // 商品信息
      userInfo: {}, // 用户信息
      appletInfo: {}, // 应用信息
      verificationPopShow: false, // 校验的弹窗
      formData: {
        clientAccount: undefined,
        decryptSelfCouponId: undefined, // 解密后的券id
      },
      siteNo: undefined,
      pageFixedScreen: false,
      receiverInfo: {},// 收获地址
    }
  },
  mounted() {
    //首页回退禁用
    history.pushState(null, null, document.URL)

    window.addEventListener('popstate', this.popstatehandle, false) // 首页禁止回退
    // window.addEventListener('pagehide', this.popstatehandle, false) // 首页禁止回退,刷新也会关闭
    wxApiEmpower()
    sessionStorage.setItem('scenPayExchangeQuery', JSON.stringify(this.$route.query)) // 缓存首页参数，其他页面登录失效的时候，将参数带回
    let _siteNo = this.$route.query.siteNo
    if (!_siteNo) {
      // 都没有siteNo的情况下，提示不合法
      return this.$toast('请携带微站编号')
    }

    this.siteNo = _siteNo
    if (sessionStorage.getItem('huijuToken')) {
      this.getInfo()
    } else {
      this.login()
    }
  },
  unmounted() {
    window.removeEventListener('popstate', this.popstatehandle, false) // 首页禁止回退
    window.removeEventListener('pagehide', this.popstatehandle, false) // 首页禁止回退
  },
  methods: {
    getInfo() {
      this.productList()
      this.getUserInfo()
      this.getAppletInfo()
    },
    login() {
      const parames = {
        siteNo: this.siteNo,
        code: sessionStorage.getItem('ydsh-ph-h5-bankv3-wxcode')
      };
      loginApi(parames).then(async (res) => {
        sessionStorage.setItem('huijuToken', res.data.token)
        this.getInfo()
      });
    },

    //  点击购买
    toBuy() {
      // 如果没有手机号,先手机号登录
      if (!this.userInfo.phone) {
        return this.$router.push('/scenarioPhoneLogin')
      }
      if (this.productData.showType === 2 && !this.formData.clientAccount) {
        return this.$toast('请输入充值账户')
      }
      // 是否需要填写地址
      const { receiverInfoSwitch } = this.appletInfo
      if (receiverInfoSwitch === 1) {
        this.$refs.addressPopupRef.open()
      } else {
        this.placeorder()
      }
    },
    // 地址确认
    addressConform(addressData) {
      this.receiverInfo = addressData
      this.placeorder()
    },
    // 下单接口
    async placeorder() {
      try {
        let cartGood = this.cartDataFormat(this.productData, 1)
        this.handleLoading(true)
        await this.checkProduct([cartGood]) // 消费券仓库查询校验
        let shopInfoList = [cartGood].map(i => {
          return {
            hjSiteProductId: i.siteProductId,
            count: i.num,
            clientAccount: this.formData.clientAccount,
          }
        })
        let parames = {
          shopInfoList,
          decryptSelfCouponId: this.formData.decryptSelfCouponId,
        };
        if (Object.keys(this.receiverInfo).length > 0) {
          parames.receiverInfoDTO = this.receiverInfo
        }
        placeorderApi(parames)
          .then((res) => {
            this.handleLoading(false)
            let data = res.data;
            if (!data.payResult) return this.$toast("支付异常！");
            let payResult = {
              timestamp: data.payResult.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: data.payResult.nonceStr, // 支付签名随机串，不长于 32 位
              package: data.payResult.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
              signType: data.payResult.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: data.payResult.paySign, // 支付签名
            };
            let _this = this;
            /* eslint-disable-next-line no-undef */
            wx.chooseWXPay({
              ...payResult,
              success() {
                _this.toRecored() // 跳到到兑换记录
              },
              complete(res) {
                console.log(res, 'complete');
                // 支付失败
                if (res.errMsg !== "chooseWXPay:ok") {
                  _this.toRecored() // 跳到到兑换记录
                }
              },
            });
          }).catch(() => {
            this.handleLoading(false)
          })
      } catch (res) {
        this.handleLoading(false)
      }
    },
    toRecored() {
      this.$router.push({
        name: 'scenarioMyOrder',
        query: {}
      })
    },
    openRule() {
      this.$refs.rulePopupRef.open()
    },
    handleLoading(val) {
      this.$refs.orderVerificationPopupRef.setShow(val)
    },

    // 获取用户信息
    getUserInfo() {
      userInfoApi().then(res => {
        this.userInfo = res.data
        this.setDefaultPhone()
        // 如果没有手机号,先手机号登录
        if (!this.userInfo.phone) {
          return this.$router.push('/scenarioPhoneLogin')
        }
      })
    },
    // 设置默认手机号, 是直充商品&产品名称不含天猫
    setDefaultPhone() {
      if (this.userInfo.phone && this.productData.showType === 2 && this.productData.productName && !this.productData.productName.includes('天猫'))
        this.formData.clientAccount = this.userInfo.phone
    },
    // 获取微站应用信息
    getAppletInfo() {
      homePageApi({}).then(res => {
        let { banner } = res.data
        if (banner && banner.topBanner) {
          let arr = JSON.parse(banner.topBanner)
          if (arr[0]) {
            res.data.topBannerUrl = arr[0].url
          }
        }
        this.appletInfo = res.data
      })
    },
    // 精选好物
    productList() {
      const arr = {
        pageNum: 1,
        pageSize: 10,
        param: {
          showPlace: 3,
        },
      };
      productList(arr).then((res) => {
        let { records } = res.data
        if (records && records.length) {
          this.productData = records[0]
          this.setDefaultPhone()
        }

        // console.log(this.productData);

      })
    },
    // 购物车更新，校验时候提交的数据格式处理
    cartDataSubmitFormat(good) {
      let cartGood = JSON.parse(JSON.stringify(good))
      cartGood.map(i => {
        i.totalPrice = i.salePrice * i.num
      })
      return cartGood
    },
    // 购物车新增数据格式处理
    cartDataFormat(good, num = 1) {
      const cartGood = {
        siteProductId: good.id,
        productNo: good.productNo,
        productName: good.productName,
        salePrice: good.salePrice,
        num: Number(num),
      }
      return cartGood
    },
    // 消费券调用券仓商品库存查询接口查询商品库存
    // (购物车格式数据) =》 {
    // 筛选出消费券数据，查询库存
    // 库存=0 提示：XXX补货中，请稍后再试！
    // 库存>0 进入订单确认页
    // }
    checkProduct(cartGood) {
      return new Promise((resolve, reject) => {
        const checkFun = async () => {
          try {
            if (cartGood.length === 0) return resolve()
            let formatList = this.cartDataSubmitFormat(cartGood)
            let shopInfoList = formatList.map(i => {
              return {
                hjSiteProductId: i.siteProductId,
                count: i.num,
              }
            })
            await checkProductApi({ shoppingTrolleyList: formatList })
            await checkCanBuyApi(shopInfoList) //  校验是否可以购买
            resolve()
          } catch (res) {
            console.error(res,);
            reject(res)
          }
        }
        checkFun()
      })
    },
    popstatehandle() {
      history.pushState(null, null, document.URL)
      if (this.isWechat()) {
        // eslint-disable-next-line
        wx.closeWindow();
      } else {
        window.close()
      }
    },
    isWechat() {
      return /MicroMessenger/i.test(window.navigator.userAgent);
    },

  },
}
</script>
<style lang="less" scoped>
.page-fixed-screen {
  height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
}
.scenario-pay-exchange-index-page {
  background: linear-gradient(0deg, #efefef, #effcf1);
  padding: 20px 0;
  .rule-btn {
    position: absolute;
    top: 70px;
    right: 0;
    .btn {
      margin-bottom: 6px;
      padding: 9px 7px;
      width: 25px;
      box-sizing: border-box;
      background: #000000;
      border-radius: 10px 0px 0px 10px;
      font-size: 12px;
      color: #ffffff;
      line-height: 1.2;
    }
  }
  .goods-conent {
    text-align: center;
    font-size: 14px;
    color: #000a1f;
    line-height: 1.5;
    h2 {
      font-weight: bold;
      font-size: 18px;
      line-height: 2;
    }
    .banner {
      margin: 10px 0;
      width: 242px;
      height: 150px;
      border-radius: 20px;
    }
    .price {
      font-weight: 600;
      font-size: 26px;
      &::before {
        content: "￥";
        font-weight: bold;
        font-size: 18px;
      }
    }
  }
  .input-content {
    margin: 10px auto;
    padding: 40px 23px;
    width: 345px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 10px;
    .input-box {
      margin-bottom: 20px;
      padding: 10px 25px;
      // border-radius: 26px;
      // border: 1px solid #999999;
      // overflow: hidden;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        top: -50%;
        left: -50%;
        width: 200%;
        height: 200%;
        border-radius: 50px;
        border: 1px solid #999999;
        transform: scale(0.5, 0.5);
      }
      :deep(.van-field) {
        z-index: 2;
        padding: 0;
      }
    }
  }
  .good-rule {
    margin: 10px auto;
    padding: 30px 23px;
    width: 345px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 10px;
    h4 {
      font-weight: bold;
      font-size: 16px;
      color: #010101;
      margin-bottom: 20px;
      text-align: center;
      &:before,
      &:after {
        content: " ";
        width: 30px;
        height: 1px;
        background: #dfdfdf;
        display: inline-block;
        margin: 5px 10px;
      }
    }
    .content {
      font-size: 13px;
      color: #808080;
      line-height: 2;
      word-wrap: break-word; /* 允许长单词和URL地址换行到下一行 */
      word-break: break-all; /* 在单词内部任意点断开单词，适应容器宽度 */
      :deep(img) {
        max-width: 100%;
        height: auto;
      }
      :deep(ul) {
        list-style-type: disc; /* 设置符号列表的符号为实心圆 */
        padding-left: 20px;
      }

      :deep(ol) {
        list-style-type: decimal; /* 设置数字列表的符号为数字 */
        padding-left: 20px;
      }
    }
  }
}
</style>
